module.exports = __webpack_public_path__ + "help_centre.bfaaddf0d83db687f52d7035ce134460.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/help_centre.svg
// module id = 348
// module chunks = 0